var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.msg)?_c('p',[_vm._v(_vm._s(_vm.msg))]):_vm._e(),_c('div',{staticClass:"login-box",attrs:{"id":"firebaseui-auth-container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }